import React, { useState } from "react";
import FormInput from "../../../props/propertyFormProp";
import UpdatePropertyForm from "./updatePropertyForm";
import UpdateAuctionForm from "./updateAuctionForm";

export default function UpdateDetailPopUp({ property, onClose }) {
    const [choice, setChoice] = useState('');
    // eslint-disable-next-line
    const [isLoading, setIsLoading] = useState(false);
    // eslint-disable-next-line
    const [error, setError] = useState('');

    // eslint-disable-next-line
    const [showUpdateForm, setShowUpdateForm] = useState(true);

    const handleCloseForm = () => {
        setShowUpdateForm(false);
        onClose();  // Ensures the popup also closes
    };
    

    const handleChange = (event) => {
        setChoice(event.target.value);
    };


    return (
        <div className="popupOverlay popupUpdateOverlay">
            {isLoading && (
                <div className="loaderContainer">
                    <div className="loader"></div>
                    <p className="loadingText"> Adding your property to auction...</p>
                </div>
            )}

            {/* If a choice is made, show only the UpdateForm */}
            {choice === 'property' ? (
                <UpdatePropertyForm 
                    myProperty={property}
                    onClose = {handleCloseForm}/>
                    
            ) : choice === 'auction' ? (
                <UpdateAuctionForm 
                    auction={property.auction}
                    onClose={handleCloseForm}
                />
            ) : (
                <div className="popupForm popUpUpdateForm">
                    <h2 className="popUpHeading popUpUpdateHeading">I want to update ...</h2>

                    <div className="forms">
                        <div className="form">
                            <form className="auctionForm updateDetailsForm">
                                {/* Property Radio */}
                                <FormInput
                                    divClass="radioInputs"
                                    label="Property"
                                    name="updateType"
                                    type="radio"
                                    value="property"
                                    onChange={handleChange}
                                    className="radio"
                                />

                                {/* Auction Radio */}
                                <FormInput
                                    divClass="radioInputs"
                                    label="Auction"
                                    name="updateType"
                                    type="radio"
                                    value="auction"
                                    onChange={handleChange}
                                    className="radio"
                                />
                            </form>
                        </div>
                    </div>
                    <div className="formButtons">
                        <button type="button" onClick={onClose} className="cancelAuction">Cancel</button>
                    </div>

                    {error && (
                        <div className="errorMessage">
                            <span className="error">{error}</span>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}
